import { createContext, useContext, useEffect, useState } from "react";
import { regionByCode, countryCodeToRegion } from "@/lib/regions";

const RegionContext = createContext(null);
const KEY = "apx_region";

export const RegionProvider = ({ children }) => {
  const [code, setCode] = useState(() => localStorage.getItem(KEY) || null);

  const setRegion = (c) => { localStorage.setItem(KEY, c); setCode(c); };

  useEffect(() => {
    if (code) return;
    let cancelled = false;
    fetch("https://ipwho.is/")
      .then((r) => r.json())
      .then((d) => { if (!cancelled) setRegion(countryCodeToRegion(d && d.country_code)); })
      .catch(() => { if (!cancelled) setRegion("GLOBAL"); });
    return () => { cancelled = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const region = regionByCode(code || "GLOBAL");
  return (
    <RegionContext.Provider value={{ region, code: code || "GLOBAL", setRegion }}>
      {children}
    </RegionContext.Provider>
  );
};

export const useRegion = () => useContext(RegionContext);
